import React, { useEffect, useState } from "react";
import { FaChurch } from "react-icons/fa";

const Loading = () => {
  const [dots, setDots] = useState("");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Animate dots
    const dotsInterval = setInterval(() => {
      setDots(prev => {
        if (prev === "...") return "";
        return prev + ".";
      });
    }, 500);

    // Simulate loading progress
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) return 100;
        return prev + Math.random() * 15;
      });
    }, 200);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(progressInterval);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center">
      <div className="relative">
        {/* Background decorative elements */}
        <div className="absolute -top-20 -left-20 w-40 h-40 bg-blue-200/30 rounded-full animate-pulse"></div>
        <div className="absolute -bottom-16 -right-16 w-32 h-32 bg-purple-200/30 rounded-full animate-pulse delay-300"></div>
        
        {/* Main loading container */}
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl p-12 text-center max-w-md mx-auto border border-white/50">
          {/* Church icon with pulsing animation */}
          <div className="relative mb-8">
            <div className="w-24 h-24 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl flex items-center justify-center mx-auto shadow-lg animate-pulse">
              <FaChurch size={48} className="text-white" />
            </div>
            {/* Ripple effect */}
            <div className="absolute inset-0 w-24 h-24 mx-auto rounded-2xl border-4 border-blue-400/50 animate-ping"></div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Adom Chapel</h1>
          <h2 className="text-xl font-semibold text-blue-700 mb-6">Management System</h2>

          {/* Loading text with animated dots */}
          <div className="mb-8">
            <p className="text-lg text-gray-600 font-medium">
              Loading{dots}
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Please wait while we prepare your dashboard
            </p>
          </div>

          {/* Progress bar */}
          <div className="mb-6">
            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full transition-all duration-300 ease-out"
                style={{ width: `${Math.min(progress, 100)}%` }}
              ></div>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              {Math.round(Math.min(progress, 100))}% Complete
            </p>
          </div>

          {/* Spinning loader */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-8 h-8 border-4 border-blue-200 rounded-full animate-spin border-t-blue-600"></div>
            </div>
          </div>

          {/* Inspirational message */}
          <div className="mt-8 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border-l-4 border-blue-500">
            <p className="text-sm text-blue-800 italic">
              "For I know the plans I have for you," declares the Lord, "plans to prosper you and not to harm you, to give you hope and a future."
            </p>
            <p className="text-xs text-blue-600 mt-1">- Jeremiah 29:11</p>
          </div>
        </div>

        {/* Floating particles */}
        <div className="absolute top-0 left-0 w-2 h-2 bg-blue-400/40 rounded-full animate-bounce delay-100"></div>
        <div className="absolute top-12 right-8 w-1 h-1 bg-indigo-400/40 rounded-full animate-bounce delay-300"></div>
        <div className="absolute bottom-8 left-12 w-1.5 h-1.5 bg-purple-400/40 rounded-full animate-bounce delay-500"></div>
        <div className="absolute top-20 left-2 w-1 h-1 bg-blue-300/40 rounded-full animate-bounce delay-700"></div>
      </div>
    </div>
  );
};

export default Loading;